// extracted by mini-css-extract-plugin
module.exports = {"FixedNav":"FixedNav_FixedNav__XbDM_"};